import isServer from '@framework/router/Next/isServer';
import styles from './fallback.module.scss';
import staticUrls from '@framework/url/staticUrls';
import IconRotate from '@dealroadshow/uikit-icon/IconRotate';

const onReloadClick = () => isServer() && window.location.reload();

interface IProps {
  className?: string,
}

const getContactLink = () => {
  return <a href={ staticUrls.getContactUsUrl() }>contact</a>;
};

const Fallback = ({ className }: IProps) => (
  <div className={ className }>
    <div className={ styles.fallbackContainer }>
      <div className={ styles.messageWrapper }>
        Something went wrong loading this component.
        Please { getContactLink() } support or <a onClick={ onReloadClick }>reload</a>
        <IconRotate
          className={ styles.reloadIcon }
          onClick={ onReloadClick }
        />
      </div>
    </div>
  </div>
);

export default Fallback;
